import { Dialog, DialogTitle, DialogContent, DialogContentText } from "@mui/material";

const CardDialog = ({ open, onClose, title, duration, text }) => <Dialog
    open={open}
    onClose={onClose}
>
    <DialogTitle variant="h5">
        {title}
    </DialogTitle>

    <DialogContent>
        {duration && <DialogContentText variant="h6">
            Срок обучения:  {duration} месяцев
        </DialogContentText>}
        <DialogContentText sx={{ mt: 2 }} color="black">
            {text}
        </DialogContentText>
    </DialogContent>
</Dialog>

export default CardDialog;